import { useCallback, useMemo } from "react";

// Groups the flat paging/action props ModelTaskTable receives into the
// shapes VirtualModelTaskRows and ModelTaskRow actually consume.
const useModelTaskChildProps = ({
	onRequestDelete,
	handleCopy,
	handleCopyTaskQuestion,
	modelId,
	customCaptions,
	access,
	totalTaskCount,
	refreshData,
	selection,
	hasPreviousPage,
	isFetchingPreviousPage,
	isFetchPreviousPageError,
	fetchPreviousPage,
	hasNextPage,
	isFetchingNextPage,
	isFetchNextPageError,
	fetchNextPage,
}) => {
	// A single-row action that changes the list leaves any multi-selection
	// stale, so it is dropped. Merely opening the row menu does not clear it,
	// since Copy and Switch To Service Layout are common and rebuilding a
	// large selection is expensive.
	const fetchData = useCallback(
		(...args) => {
			selection.clear();
			return refreshData(...args);
		},
		[refreshData, selection]
	);
	const rowProps = useMemo(
		() => ({
			onRequestDelete,
			handleCopy,
			handleCopyTaskQuestion,
			modelId,
			customCaptions,
			access,
			totalTaskCount,
			fetchData,
		}),
		[
			access,
			customCaptions,
			fetchData,
			handleCopy,
			handleCopyTaskQuestion,
			modelId,
			onRequestDelete,
			totalTaskCount,
		]
	);
	const previousPage = useMemo(
		() => ({
			hasPage: hasPreviousPage,
			isFetching: isFetchingPreviousPage,
			isError: isFetchPreviousPageError,
			fetch: fetchPreviousPage,
		}),
		[fetchPreviousPage, hasPreviousPage, isFetchPreviousPageError, isFetchingPreviousPage]
	);
	const nextPage = useMemo(
		() => ({
			hasPage: hasNextPage,
			isFetching: isFetchingNextPage,
			isError: isFetchNextPageError,
			fetch: fetchNextPage,
		}),
		[fetchNextPage, hasNextPage, isFetchNextPageError, isFetchingNextPage]
	);

	return { rowProps, previousPage, nextPage };
};

export default useModelTaskChildProps;
